import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/ui/Button';
import HeroSection from './components/HeroSection';
import BenefitsSection from './components/BenefitsSection';
import FeaturesPreview from './components/FeaturesPreview';
import SocialProof from './components/SocialProof';
import TrustSignals from './components/TrustSignals';
import CTASection from './components/CTASection';
import { useAuth } from '../../contexts/AuthContext';

const LandingPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleSignup = () => {
    navigate('/partner-onboarding');
  };

  const handleLogin = () => {
    // Check if user is already authenticated
    if (user) {
      navigate('/shared-profile-dashboard');
    } else {
      // Redirect to login page if not authenticated
      navigate('/login');
    }
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Navigation Header */}
      <header className="fixed top-0 left-0 right-0 z-navigation bg-card/95 backdrop-blur-sm border-b border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
              <span className="text-primary-foreground font-heading font-semibold text-lg">LN</span>
            </div>
            <span className="font-heading text-xl font-semibold text-foreground">LoveNudge</span>
          </div>
          <div className="flex items-center space-x-3">
            <Button
              variant="ghost"
              size="sm"
              onClick={handleLogin}
              className="hidden sm:inline-flex"
            >
              Welcome Back
            </Button>
            <Button
              variant="default"
              size="sm"
              onClick={handleSignup}
            >
              Get Started Free
            </Button>
          </div>
        </div>
      </header>
      {/* Main Content */}
      <main className="pt-20">
        <HeroSection onSignup={handleSignup} onLogin={handleLogin} />
        <BenefitsSection />
        <FeaturesPreview />
        <SocialProof />
        <TrustSignals />
        <CTASection onSignup={handleSignup} />
      </main>
      {/* Footer */}
      <footer className="bg-muted border-t border-border py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="col-span-1 md:col-span-2">
              <div className="flex items-center space-x-2 mb-4">
                <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
                  <span className="text-primary-foreground font-heading font-semibold text-lg">LN</span>
                </div>
                <span className="font-heading text-xl font-semibold text-foreground">LoveNudge</span>
              </div>
              <p className="text-muted-foreground text-sm max-w-md">
                Strengthen your connection through AI-guided intimacy. Private, secure, and designed for couples who value their relationship.
              </p>
            </div>
            <div>
              <h4 className="font-heading font-semibold text-foreground mb-3">Product</h4>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li><button onClick={handleSignup} className="hover:text-foreground transition-colors">Features</button></li>
                <li><button onClick={handleSignup} className="hover:text-foreground transition-colors">Pricing</button></li>
                <li><button className="hover:text-foreground transition-colors">Security</button></li>
              </ul>
            </div>
            <div>
              <h4 className="font-heading font-semibold text-foreground mb-3">Company</h4>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li><button className="hover:text-foreground transition-colors">About</button></li>
                <li><button className="hover:text-foreground transition-colors">Privacy Policy</button></li>
                <li><button className="hover:text-foreground transition-colors">Terms of Service</button></li>
              </ul>
            </div>
          </div>
          <div className="mt-8 pt-8 border-t border-border text-center text-sm text-muted-foreground">
            <p>&copy; {new Date()?.getFullYear()} LoveNudge. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;